<template>
  <Combobox v-model="selectedItem" as="div">
    <ComboboxLabel class="block text-sm font-medium text-gray-700">{{
      label
    }}</ComboboxLabel>
    <div class="relative mt-1">
      <ComboboxInput
        class="w-full rounded-md border border-gray-300 bg-white py-2 pr-10 pl-3 shadow-xs focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-hidden sm:text-sm"
        :displayValue="(item) => item?.name"
        @change="query = $event.target.value"
      />
      <ComboboxButton
        class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-hidden"
      >
        <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
      </ComboboxButton>

      <ComboboxOptions
        v-if="filteredList.length > 0"
        class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 shadow-lg ring-black/5 focus:outline-hidden sm:text-sm"
      >
        <ComboboxOption
          v-for="(item, index) in filteredList"
          :key="index"
          v-slot="{ active, selected }"
          :value="item"
          as="template"
        >
          <li
            :class="[
              'relative cursor-default py-2 pr-9 pl-3 select-none',
              active ? 'bg-indigo-600 text-white' : 'text-gray-900',
            ]"
          >
            <span :class="['block truncate', selected && 'font-semibold']">
              {{ item.name }}
            </span>

            <span
              v-if="selected"
              :class="[
                'absolute inset-y-0 right-0 flex items-center pr-4',
                active ? 'text-white' : 'text-indigo-600',
              ]"
            >
              <CheckIcon class="h-5 w-5" aria-hidden="true" />
            </span>
          </li>
        </ComboboxOption>
      </ComboboxOptions>
    </div>
  </Combobox>
</template>

<script setup>
import { computed, ref } from 'vue'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid'
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/vue'

const props = defineProps({
  list: {
    type: Array,
    required: true,
  },
  selectedValue: {
    type: Object,
    default: () => {},
  },
  label: {
    type: String,
    default: '',
  },
})
const emit = defineEmits(['updateSelected'])

const query = ref('')
const filteredList = computed(() =>
  query.value === ''
    ? props.list
    : props.list.filter((item) => {
        return item.name.toLowerCase().includes(query.value.toLowerCase())
      }),
)
const selectedItem = computed({
  get() {
    return props.selectedValue
  },
  set(newValue) {
    if (newValue) {
      emit('updateSelected', newValue)
    }
  },
})
</script>
